<template>
  <div class="height-90">
    <profile-app-bar />
    <v-container  fill-height>
      <v-row align="center">
        <v-col>
          <v-row justify="center">
            <div class="submitted-logo"></div>
          </v-row>
          <v-row justify="center">
            <div class="primaryText--text title">Application Submitted</div>
          </v-row>
          <v-row justify="center">
            <div class="body-2 primaryText--text text-center mt-4">
              Your application has been submitted successfully.<br />
              You will receive a confirmation email soon
            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
  
<script>
import ProfileAppBar from "../components/ProfileAppBar";
export default {  
  name: "ApplicationSubmittedScreen",
  components: {
    ProfileAppBar
  }
};
</script>
      

<style lang="scss" scoped>
.submitted-logo {
  background: url("../assets/application_submitted.svg") no-repeat;
  width: 390px;
  height: 324px;
}
</style>
       